import React from "react";
import { Container, Row, Col } from "react-bootstrap";

const About = () => {
  return (
    <Container className="about pb-5 px-5 z-1" id="about" fluid>
      <Row>
        <Col lg={7} className="d-flex flex-column justify-content-center my-5">
          <Row className="mt-5">
            <Col className="text-center">
              <h1 className="fw-bolder mb-5">What is the IFMF?</h1>
            </Col>
          </Row>
          <Row className="mb-5">
            <p className="about-paragraph">
                The <b>Interest-Free Mortgage Fund</b> (IFMF) is a community-based initiative designed to help members acquire homes without the burden of interest-based loans. By pooling funds and distributing them fairly, we ensure every participant moves toward homeownership in a sustainable way.
            </p>
          </Row>
          <Row className="mt-5">
            <Col className="text-center">
              <h1 className="fw-bolder mb-5">HOW IT WORKS</h1>
            </Col>
          </Row>
          <Row className="mb-5">
            <p className="about-paragraph">
                IF Holdings is pioneering this interest-free mortgage fund to provide its members with a practical, affordable path to homeownership and financial well-being.
            </p>

            <ul>
                <li className="how-it-works-list-item"><b>Join the Fund</b> – Become a member by meeting eligibility requirements.</li>
                <li className="how-it-works-list-item"><b>Contribute Regularly</b> – Your contributions help build the fund.</li>
                <li className="how-it-works-list-item"><b>Receive Your Home Financing</b> – Members are selected based on a fair, transparent process.</li>
                <li className="how-it-works-list-item"><b>Repay Without Interest</b> – Pay back the amount over time, making the fund sustainable for others.</li>
            </ul>
          </Row>
          <Row>
            <p className="about-paragraph text-center">
                The more members contribute and refer others, the faster the fund grows!
            </p>
          </Row>
        </Col>

        <Col>
          <img
            src="./images/about.jpg"
            className="img-fluid position-sticky about-img"
            alt="commitment-only-about-image"
          />
        </Col>
      </Row>
    </Container>
  );
};

export default About;
